import { MessagePreview } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

interface Props {
  previewMessage: MessagePreview
}

export const EmbedAttachmentPreview = ({ previewMessage }: Props) => {
  const { attachmentPreview, imagePreview, embedPreview, preview } =
    previewMessage

  if (!attachmentPreview) {
    return null
  }

  if (preview || embedPreview || imagePreview) {
    return <SvgIcon name="embed" size="lg" />
  }

  return (
    <div className="flex items-center gap-x-1 truncate">
      <SvgIcon name="embed" size="lg" />
      <span className="text-content-subdued truncate">{embedPreview.url}</span>
    </div>
  )
}
